<template>
  <div  style="margin: 0px 20px">
    <a-tabs
      v-model="advancedKey"
      :tabBarStyle="{  borderBottom: 'unset' }">
      <a-tab-pane key="1" tab="患者列表">
        <patient-index urlList="/patient/patientForm/checkPatientList" :parentBaseQueryParam="parentBaseQueryParam" :formSearch="true" @handleView="handleSelect" :isRegister="false">
          <template slot="btn">
            <a-radio-group  v-model="parentBaseQueryParam.status" >
              <a-radio-button :value="'0'">
                未审核完成
              </a-radio-button>
              <a-radio-button :value="'1'">
                已审核完成
              </a-radio-button>
            </a-radio-group>
          </template>
        </patient-index>
      </a-tab-pane>
      <a-tab-pane key="2" tab="核查列表">
        <check-list ref="check-list" :handle-status-query="true"></check-list>
      </a-tab-pane>
    </a-tabs>


  </div>
</template>

<script>

  import PatientIndex from '@/views/project/patient/components/register/PatientIndex'
  import CheckList from './check/CheckList'
  export default {
    name: 'Check',
    components: { CheckList, PatientIndex },    
    data(){
      return {
        advancedKey:'1',
        parentBaseQueryParam:{
          status:'0'
        },
      }
    },
    watch: {
      '$route.query.userId': {
        handler: function(newUserId, oldUserId) {
          console.log(`新的 userId: ${newUserId}, 旧的 userId: ${oldUserId}`);
          if (newUserId) {
            this.$set(this.parentBaseQueryParam,'supper','{"userIdList":['+newUserId+']}')
          }
        },
        immediate: true // 立即以当前值触发处理器
      }
    },
    mounted(){
      console.log("userId:----------")
      var userId= this.$route.query.userId
      console.log("userId:"+userId)

      if(userId){
        this.$set(this.parentBaseQueryParam,'supper','{"userIdList":['+this.userId+']}')
      }
    },
    methods:{

      handleSelect(record){
        this.advancedKey = '2'
        this.$nextTick(()=>{
          this.$refs['check-list'].loadByPatient(record)
        })
      },
    }
  }
</script>

<style scoped lang="less">

</style>